import { render, staticRenderFns } from "./CenteredIcon.vue?vue&type=template&id=485fe0df&"
import script from "./CenteredIcon.vue?vue&type=script&lang=js&"
export * from "./CenteredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports